var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchedPosition({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9568 3.04797C12.9031 -1.15916 6.65602 -0.862274 2.91234 3.02319C-0.878911 6.95817 -1.06971 13.5413 2.93622 17.6991L9.96995 25L17.0281 17.6742C20.7002 13.8631 21.2963 7.55233 16.9567 3.04807L16.9568 3.04797Z",
    fill: "#C50000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 5,
    fill: "#800000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchedPosition);
export default __webpack_public_path__ + "static/media/searchedPosition.bed233ac3748407de1cd3e9bbc4751a3.svg";
export { ForwardRef as ReactComponent };